import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

interface singleInputProps {
  onInputChange: React.ChangeEventHandler<HTMLInputElement>;
  value?: string | number;
  placeholder: string;
  subTitle?: string;
  emailError?: string;
  InputType?: string;
}

const FormSingleInput: React.FC<singleInputProps> = ({
  onInputChange,
  value,
  placeholder,
  subTitle,
  emailError,
  InputType,
}) => {
  return (
    <React.Fragment>
      <Box sx={{ marginTop: "15px" }}>
        {subTitle && (
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#333333",
              opacity: 0.6,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "15px", xl: "20px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
            }}
          >
            {subTitle}
          </Typography>
        )}
        <TextField
          required={true}
          placeholder={placeholder}
          onChange={onInputChange}
          type={InputType ? "number" : "text"}
          value={value !== "" ? (value !== 0 ? value : "") : ""}
          sx={{
            paddingBottom: 0,
            fontWeight: 500,
            background: "#F8F8F8",
            borderRadius: "4px",
            "& .MuiOutlinedInput-root": {
              width: { xs: "320px", md: "407px", xl: "553px" },
              height: { xs: "45px", md: "49px", xl: "60px" },
              fontFamily: "Avenir",
              letterSpacing: "0.5px",
              color: "#333333",
              opacity: 1,
              borderRadius: "4px",
              fontSize: {
                xs: "12px",
                sm: "14px",
                md: "16px",
                xl: "22px",
              },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "30px",
                xl: "30px",
              },
              "& fieldset": {
                border: "1px solid #94949533",
              },
              "&:hover fieldset": {
                border: "1px solid #94949533",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#94949533",
              },
            },
          }}
        />
        {emailError !== "" && (
          <Typography
            sx={{
              letterSpacing: "0px",
              color: "#FF5247",
              opacity: 1,
              fontFamily: "Avenir",
              fontSize: { xs: "11px", sm: "13px", md: "16px", xl: "22px" },
              lineHeight: {
                xs: "20px",
                sm: "22px",
                md: "24px",
                xl: "27px",
              },
              marginBottom: "4px",
              marginTop: "8px",
            }}
          >
            {emailError}
          </Typography>
        )}
      </Box>
    </React.Fragment>
  );
};

export default FormSingleInput;
